import { atom  } from "recoil";

export const sideBarActiveMenu = atom({
    key: "sideBarActiveMenu",
    default: {
      newDeliveryItem : true, 
      deliveriesItem : false, 
      dashboardItem : false, 
      supportItem: false
    },
});